import { z } from 'zod';

export const salesRepDtoSchema = z.object({
    salesRepId: z.string(),
    salesRepName: z.string(),
    isInternal: z.boolean().optional(),
});

export type SalesRepDTO = z.infer<typeof salesRepDtoSchema>;
